import cn from 'classnames';
import Svg from 'UI/components/Svg';
import LinkWrapper from 'UI/components/LinkWrapper';
import { routes } from 'utils/routes';
import useCardsSection from './utils/useCardsSection';
import styles from './AssessmentCtaSection.module.scss';

const AssessmentCtaSection = (props) => {
  const {
    className,
  } = useCardsSection(props);

  // DEPRICATED
  // const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.sectionContainer}>
      <LinkWrapper
        path={routes.assessments.path}
        className={cn(styles.badge)}
      >
        Take Assessment
        <span
          className={styles.arrow}
        >
          <Svg
            type="arrowRight"
            className={styles.icon}
          />
        </span>
      </LinkWrapper>
      {/* DEPRECATED */}
      {/* <section className={cn(className, { [styles.isOpen]: isOpen })}>
        <div
          onClick={() => setIsOpen(false)}
          className={styles.close}
        >
          <Svg
            type="xClose"
            className={styles.icon}
          />
        </div>
        <CardsSection {...props} />
      </section> */}
    </div>
  );
};

export default AssessmentCtaSection;
